const socialHosts: Record<string, readonly string[]> = {
  facebook: ['facebook.com', 'www.facebook.com', 'm.facebook.com'],
  instagram: ['instagram.com', 'www.instagram.com'],
  tiktok: ['tiktok.com', 'www.tiktok.com'],
  linkedin: ['linkedin.com', 'www.linkedin.com'],
  youtube: ['youtube.com', 'www.youtube.com', 'youtu.be'],
  x: ['x.com', 'www.x.com', 'twitter.com', 'www.twitter.com'],
  spotify: ['open.spotify.com'],
  whatsapp: ['wa.me', 'api.whatsapp.com'],
};

export function isSafeLandingSocialHref(platform: string, href: string) {
  try {
    const url = new URL(href);
    const customDestination = ['custom', 'phone', 'android', 'ios'].includes(platform);
    return href.startsWith('https://') && url.protocol === 'https:' && !url.username && !url.password && !url.port &&
      !/[\s\\]/.test(href) && !Array.from(href).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127) &&
      (customDestination || (Boolean(socialHosts[platform]?.includes(url.hostname)) && url.pathname !== '/'));
  } catch {
    return false;
  }
}
